<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <c-table
        ref="equipmentGradeTable"
        title="설비등급 변경이력"
        tableId="equipmentGradeTable"
        :columns="grid.columns"
        :data="grid.data"
        @rowClick="rowClick"
        :hide-bottom="true"
        :hide-pagination="true"
        :isFullScreen="false"
        :columnSetting="false"
        :filtering="false"
      >
      </c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
      <q-form ref="editForm">
        <c-card title="설비등급 변경정보" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <c-btn v-if="editable && addMode" label="신규" icon="add" @btnClicked="addRank" />
              <c-btn v-if="editable && revisionMode" label="개정" icon="restart_alt" @btnClicked="revisionRank" />
              <c-btn
                v-if="editable"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="data"
                :mappingType="saveType"
                label="저장"
                icon="save"
                @beforeAction="saveRank"
                @btnCallback="saveCallback" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-4">
              <c-select
                :required="true"
                codeGroupCd="MDM_EQUIP_GRADE_CD"
                type="edit"
                itemText="codeName"
                itemValue="code"
                name="grade"
                label="위험등급"
                v-model="data.grade"
                :editable="editable && updateMode"
              ></c-select>
            </div>
            <div class="col-4">
              <c-datepicker
                :required="true"
                :editable="editable && updateMode"
                label="등급변경일"
                name="gradeDate"
                v-model="data.gradeDate"
              />
            </div>
            <div class="col-4">
              <c-text
                :required="true"
                :editable="editable && updateMode"
                label="평가점수"
                type="number"
                name="estimationScore"
                v-model="data.estimationScore">
              </c-text>
            </div>
            <div class="col-12">
              <c-textarea
                :required="true"
                :editable="editable && updateMode"
                label="등급변경사유"
                name="changeReason"
                v-model="data.changeReason">
              </c-textarea>
            </div>
            <div class="col-12">
              <c-upload
                :editable="editable"
                label="설비중요도 등급평가표">
              </c-upload>
            </div>
          </template>
        </c-card>
      </q-form>
    </div>
  </div>
</template>
1
<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'equipment-grade',
  props: {
    param: {
      type: Object,
      default: () => ({
        equipmentCd: '',
        plantName: '',
        plantCd: '',
        equipmentTypeName: '',
        equipmentName: '',
      }),
    },
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'gradeDate',
            field: 'gradeDate',
            label: '등급변경일',
            align: 'center',
            sortable: false,
          },
          {
            name: 'gradeName',
            field: 'gradeName',
            label: '설비등급',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
      data: {
        plantCd: null,
        equipmentCd: '',
        recordNo: '',
        grade: null,
        estimationScore: '',
        gradeDate: '',
        changeReason: '',
        regUserId: '',
        chgUserId: '',
      },
      listUrl: '',
      detailUrl: '',
      editable: true,
      updateMode: false,
      revisionMode: false,
      addMode: false,
      isSave: false,
      saveUrl: transactionConfig.mdm.equipment.rank.save.url,
      saveType: 'POST',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.mdm.equipment.rank.list.url;
      this.detailUrl = selectConfig.mdm.equipment.rank.get.url;
      this.saveUrl = transactionConfig.mdm.equipment.rank.save.url;
      // list scope
      this.getRankList();
    },
    rowRemoveSelect() {
      var _table = document.getElementsByClassName('bg-light-blue-1')[0];
      if (_table) {
        _table.classList.remove('bg-light-blue-1');
      }
    },
    getRankList() {
      this.getList();
      this.rowRemoveSelect();
    },
    getList() {
      this.rowNotSelected = true;
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.param.plantCd,
        equipmentCd: this.param.equipmentCd,
      };
      this.$http.request((_result) => {
        if (_result.data.length > 0) {
          this.grid.data = _result.data;
          this.reset();
          this.addMode = false;
          this.updateMode = false;
        } else {
          this.reset();
          this.addMode = true;
        }
      },);
    },
    rowClick(row) {
      this.updateMode = false;
      this.$http.url = this.detailUrl;
      this.$http.param = {
        plantCd: row.plantCd,
        equipmentCd: row.equipmentCd,
        recordNo: row.recordNo,
      };
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        this.data.editFlag = 'U';
        this.revisionMode = true;
      },
      () => {
      });
    },
    addRank() {
      this.updateMode = true;
      this.reset();
      this.data.gradeDate = this.$comm.getToday();
    },
    reset() {
      this.rowRemoveSelect();
      this.data = {
        editFlag: 'C',
        plantCd: this.param.plantCd,
        equipmentCd: this.param.equipmentCd,
        recordNo: '',
        grade: null,
        estimationScore: '',
        gradeDate: '',
        changeReason: '',
        regUserId: '',
        chgUserId: '',
      };
    },
    revisionRank() {
      this.rowRemoveSelect();
      this.data = {
        editFlag: 'R',
        plantCd: this.param.plantCd,
        equipmentCd: this.param.equipmentCd,
        recordNo: '',
        grade: null,
        estimationScore: '',
        gradeDate: this.$comm.getToday(),
        changeReason: '',
        regUserId: '',
        chgUserId: '',
      };
      this.updateMode = true;
    },
    saveRank() {
      this.$refs['editForm'].validate().then(_result => {
        // 중복체크
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.isSave = !this.isSave;
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.addMode = false;
      this.getRankList();
    },
  }
};
</script>